import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { CAR_BRAND_PREFIX_URL } from './constants/config.car-brand'

const ListPage = lazy(() => import('./pages/ListPage.CarBrand'))

const CarBrandRouters: AppRouterItem[] = [
  {
    path: `${CAR_BRAND_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default CarBrandRouters
